import { useState } from 'react';

const blogPosts = [
  {
    id: '1_2MtcODBQbxWXc6ZPAh3Ez5FZJR6fB1C',
    image: '/images/blog/1.jpg',
    title: 'The Ultimate Guide to Creating Emotionally Powerful Wedding Films',
    excerpt: 'We create emotionally powerful wedding films through cinematic editing and heartfelt storytelling, turning real moments into lasting memories.',
    content: {
      intro: 'Emotionally powerful wedding films go beyond documenting events. They capture real feelings, genuine reactions, and meaningful moments. With the right wedding video editing approach, raw footage becomes a cinematic wedding film couples can relive forever.',
      sections: [
        { title: 'Build a Strong Emotional Foundation', text: 'Every great wedding film storytelling process starts with understanding the couple. Their personalities, traditions, and wedding atmosphere shape the emotional tone. A strong foundation helps create consistent and emotionally engaging wedding video edits.' },
        { title: 'Capture Authentic and Emotional Moments', text: 'Authentic moments are the heart of emotional wedding video editing. Natural smiles, quiet tears, and candid interactions make wedding films feel real. These genuine moments help create cinematic wedding films that truly connect.' },
        { title: 'Control Emotion Through Pacing and Rhythm', text: 'Pacing plays a key role in wedding highlight film editing. Slow sequences build romance, while faster cuts add excitement. Matching rhythm with emotion ensures smooth and impactful wedding film storytelling.' },
        { title: 'Create Seamless Storytelling with Sound', text: 'Sound design enhances emotional depth in wedding films. Clean vows, heartfelt speeches, and ambient audio create realism. When combined with music, sound turns wedding video editing into a complete emotional experience.' },
        { title: 'Enhance Mood with Cinematic Color Grading', text: 'Wedding film color grading directly influences emotion. Warm tones express love and joy, while cooler shades add elegance. Consistent cinematic color grading gives wedding videos a polished and professional look.' },
        { title: 'Use Music to Strengthen Emotional Storytelling', text: 'Music selection is essential in emotional wedding films. Soft tracks support intimate moments, while energetic songs elevate celebrations. Syncing cuts to music creates a natural flow in cinematic wedding video editing.' },
        { title: 'Keep Wedding Films Simple and Timeless', text: 'Simple edits often create the strongest emotional impact. Avoid overusing effects that distract from the story. Clean transitions and natural pauses help emotional wedding films feel timeless and authentic.' },
        { title: 'Deliver a Personalized Wedding Film Experience', text: 'Personalization sets professional wedding video editing apart. Including vows, speeches, and meaningful candid moments makes each film unique. A personalized wedding film helps couples feel emotionally connected every time they watch.' }
      ],
      conclusion: 'Emotionally powerful wedding films are built with care, storytelling, and empathy. Thoughtful wedding video editing transforms moments into lasting memories. The goal is not just to show the wedding day, but to make couples feel it again.'
    }
  },
  {
    id: '1taz-EdwQo_hCTW8CRrQ3kNWVCLQ9t0pJ',
    image: '/images/blog/2.jpg',
    title: 'From Raw Footage to Fairytale: How Cinematic Wedding Films Are Created',
    excerpt: 'Discover how outsourcing your editing process saves time, reduces stress, and allows you to focus more on shooting and client relations, leading to business growth.',
    content: {
      intro: 'Cinematic wedding films begin as raw footage filled with emotion and movement. Through professional wedding video editing, these moments are shaped into meaningful stories. The goal is to create emotionally powerful wedding films that couples can relive for years.',
      sections: [
        { title: 'Organizing Raw Wedding Footage for a Smooth Workflow', text: 'Wedding video editing starts with sorting and organizing raw clips. Ceremony footage, speeches, couple shots, and candid moments are carefully arranged. This structured process ensures no emotional detail is missed and improves editing efficiency.' },
        { title: 'Building a Story-Driven Cinematic Wedding Film', text: 'Strong wedding film storytelling focuses on emotion, not just timelines. Editors structure the film to flow naturally from preparation to celebration. This approach creates cinematic wedding films that feel engaging and professionally crafted.' },
        { title: 'Choosing Visuals That Enhance Emotional Impact', text: 'Emotional wedding video editing relies on thoughtful shot selection. Close-ups highlight intimacy, while wide shots capture celebration and energy. Every clip is chosen to strengthen emotional connection and cinematic storytelling.' },
        { title: 'Wedding Film Color Grading for Mood and Consistency', text: 'Professional wedding film color grading shapes the mood of the story. Warm tones enhance romance, while balanced contrast adds depth and clarity. Consistent color grading gives wedding videos a polished cinematic look.' },
        { title: 'Music Selection in Cinematic Wedding Video Editing', text: 'Music plays a major role in emotional wedding films. Editors choose soundtracks that reflect the couple\'s personality and wedding atmosphere. Proper beat matching helps guide emotion throughout the film.' },
        { title: 'Pacing and Timing in Wedding Highlight Film Editing', text: 'Pacing controls how a wedding film feels. Slow edits emphasize emotional moments, while faster cuts energize reception scenes. Balanced timing keeps wedding highlight films engaging and emotionally strong.' },
        { title: 'Creating Multiple Wedding Video Edits for Modern Couples', text: 'Professional wedding video editing services often include multiple versions. Short teaser reels suit social media, while highlight and feature films offer deeper storytelling. This flexibility adds value for studios and couples.' }
      ],
      conclusion: 'Cinematic wedding films are created through careful storytelling and technical skill. From raw footage to final delivery, every step adds emotional depth. Professional wedding video editing turns moments into memories that last forever.'
    }
  },
  {
    id: '1aPJXDJsjBIW4JVCkILUs1wUZQWPkNFmq',
    image: '/images/blog/3.jpg',
    title: 'The Future of Wedding Videography: Why Outsourced Editing Is Here to Stay',
    excerpt: 'We review the essential software and hardware, from fast storage to powerful GPUs, that will boost your productivity and final video output quality this year.',
    content: {
      intro: 'Wedding videography has evolved beyond simple event coverage. Couples now expect cinematic wedding films that feel emotional and personalized. Outsourced wedding video editing helps meet these expectations by delivering consistent quality while keeping the creative process efficient.',
      sections: [
        { title: 'The Shift from Traditional Videos to Cinematic Wedding Films', text: 'Wedding films today focus on storytelling, emotion, and visual style. Multi-camera coverage, drone footage, and curated music have become standard. This shift has increased the demand for skilled wedding video editing services, making outsourcing a natural solution.' },
        { title: 'Why Outsourced Wedding Video Editing Saves Time', text: 'Editing wedding films requires careful attention and many hours of work. Outsourcing wedding video editing allows projects to move forward without delays. Faster turnaround times help ensure couples receive their wedding films without long waiting periods.' },
        { title: 'Access to Specialized Wedding Film Editing Skills', text: 'Outsourcing provides access to experienced wedding film editors with diverse styles. From romantic highlights to documentary-style edits, professional wedding video editing services offer creative flexibility. This variety helps deliver films that match different wedding stories.' },
        { title: 'Maintaining Quality and Consistency in Wedding Films', text: 'Consistency is key in cinematic wedding films. Outsourced editing teams follow clear guidelines for color grading, pacing, and transitions. This approach ensures every wedding video maintains a polished and cohesive look.' },
        { title: 'Outsourcing as a Scalable Editing Solution', text: 'Wedding seasons can be unpredictable and demanding. Outsourced wedding video editing offers flexibility during busy periods without long-term commitments. This scalable solution helps manage workload smoothly while maintaining quality.' }
      ],
      conclusion: 'Outsourced wedding video editing is becoming a standard part of modern videography. It supports creativity, efficiency, and consistent results. As expectations grow, outsourcing continues to play a key role in the future of cinematic wedding films.'
    }
  },
  {
    id: '1elWGk7RR6ueGamgUy8_wNKKSIf6curqj',
    image: '/images/blog/4.jpg',
    title: 'The Secret to Timeless Wedding Films: Editing That Speaks from the Heart',
    excerpt: 'Music is key to emotion. We cover licensing basics and recommend the best royalty-free platforms to find the perfect soundtrack legally and easily.',
    content: {
      intro: 'Modern wedding videography uses advanced cameras and tools, but emotion remains the heart of every timeless wedding film. Emotional wedding video editing transforms raw footage into stories that feel personal and real. A cinematic wedding film succeeds when viewers don\'t just see moments — they feel them.',
      sections: [
        { title: 'Emotional Storytelling in Wedding Video Editing', text: 'Every wedding has emotional moments that shape its story. From nervous smiles to heartfelt tears, these scenes create connection. Emotional wedding video editing focuses on building a natural emotional flow rather than simply arranging events.' },
        { title: 'Authentic Moments Create Timeless Wedding Films', text: 'Perfect shots are not always the most meaningful. Real laughter, unscripted hugs, and emotional reactions add authenticity to cinematic wedding films. Keeping these moments makes wedding video storytelling feel honest and timeless.' },
        { title: 'Using Pacing and Transitions to Guide Emotion', text: 'Pacing controls how emotions rise and settle in a wedding film. Slow transitions create intimacy, while faster cuts bring energy to celebration scenes. Balanced pacing is essential for smooth and engaging wedding video editing.' },
        { title: 'Wedding Film Color Grading and Emotional Impact', text: 'Color grading influences how a wedding film feels. Warm tones add romance and nostalgia, while softer shades create calm and intimacy. Professional wedding film color grading enhances emotion without overpowering the story.' },
        { title: 'Sound Design in Emotional Wedding Films', text: 'Audio brings depth to wedding video storytelling. Vows, speeches, ambient sounds, and music must blend naturally. Thoughtful sound design turns wedding videos into immersive emotional experiences.' },
        { title: 'The Power of Minimal Editing in Wedding Videos', text: 'Not every moment needs heavy effects or fast cuts. Simple editing allows emotional scenes to breathe and feel natural. Minimal wedding video editing often creates the strongest emotional impact.' }
      ],
      conclusion: 'Timeless wedding films are built on emotion, not technology alone. When editing focuses on feeling, flow, color, and sound, the result becomes unforgettable. Emotional wedding video editing turns moments into memories that last for generations.'
    }
  },
  {
    id: '1WkYVzJbsjwvgOn18wJduXeonEjV9r5lP',
    image: '/images/blog/5.jpg',
    title: 'Elevate Your Wedding Films with Professional Editing Techniques',
    excerpt: 'Bad audio ruins a great video. Learn simple mic setups and advanced editing techniques to capture and clean up flawless sound for your wedding films.',
    content: {
      intro: 'Every wedding film starts with meaningful moments, but professional wedding video editing gives them life. Editing shapes emotion, rhythm, and visual flow into cinematic wedding films couples treasure. Stunning results come from storytelling, not just technical perfection.',
      sections: [
        { title: 'Creating an Efficient Wedding Video Editing Workflow', text: 'A clear workflow is essential for consistent wedding video editing. Organizing ceremony clips, reception footage, and candid moments saves time and reduces errors. A structured process allows editors to focus on creativity and cinematic storytelling.' },
        { title: 'Storytelling Techniques for Cinematic Wedding Films', text: 'Wedding video storytelling goes beyond chronological edits. Emotional moments like vows, reactions, and celebrations guide the narrative. Strong cinematic wedding films balance pacing and emotion to create a natural, engaging flow.' },
        { title: 'Color Correction and LUTs for a Cinematic Look', text: 'Wedding film color grading sets the mood and visual tone. Correcting exposure and white balance creates a clean base before applying LUTs. Subtle, consistent grading enhances emotion without overpowering the story.' },
        { title: 'Music Selection and Sound Design in Wedding Films', text: 'Music drives emotion in cinematic wedding video editing. Choosing the right licensed soundtrack enhances storytelling and mood. Blending music with natural audio like vows and laughter creates immersive wedding films.' },
        { title: 'Optimizing Wedding Videos for Online Platforms', text: 'Online optimization increases visibility for wedding films. YouTube benefits from SEO-friendly titles and descriptions, while Instagram favors short, emotional reels. Proper formatting helps wedding video editing reach a wider audience.' },
        { title: 'Wedding Video Editing Mistakes to Avoid', text: 'Overusing transitions or ignoring audio quality can weaken emotional impact. Inconsistent color grading and rushed pacing reduce professionalism. Avoiding these mistakes ensures polished and emotionally strong wedding films.' },
        { title: 'Maintaining a Consistent Wedding Editing Style', text: 'Consistency builds recognition and trust. Using preset templates, color styles, and pacing rules strengthens brand identity. A consistent wedding video editing style makes every project feel refined and reliable.' }
      ],
      conclusion: 'Professional wedding video editing transforms moments into lasting memories. With strong workflow, emotional storytelling, and attention to detail, wedding films become timeless. Emotion, not effects, is what makes a wedding film unforgettable.'
    }
  },
  {
    id: '1vYM5T2Z-7aHCsRyNAsG7WZUGl9WZUgHY',
    image: '/images/blog/6.jpg',
    title: 'Mastering Client Experience in Wedding Films: How Communication Shapes Cinematic Stories',
    excerpt: 'Get an inside look at our editing process and discover the dedication and creativity that goes into crafting each unique wedding story.',
    content: {
      intro: 'Great wedding films begin long before editing starts. Clear communication helps wedding video editors understand emotions, expectations, and personal stories. Strong collaboration leads to emotional wedding video editing that feels authentic, personal, and timeless.',
      sections: [
        { title: 'Understanding the Couple\'s Story Before Wedding Video Editing', text: 'Every wedding film is rooted in a personal journey. Learning about the couple\'s relationship, traditions, and emotional priorities helps guide creative decisions. This approach strengthens wedding video storytelling and ensures the edit reflects their true story.' },
        { title: 'Building Trust Through Clear Client Communication', text: 'Trust grows when communication is honest and consistent. Sharing timelines, revision policies, and delivery methods sets clear expectations. Transparent communication supports smooth wedding video editing workflows and creates confident, relaxed clients.' },
        { title: 'Collecting Meaningful Feedback for Better Wedding Films', text: 'Effective feedback improves emotional wedding films. Guiding clients to comment on pacing, mood, and storytelling avoids confusion. Organized feedback helps wedding video editors refine films while preserving cinematic flow.' },
        { title: 'Collaborating on Music and Emotional Tone', text: 'Music plays a powerful role in cinematic wedding films. Involving clients in song selection ensures the emotional tone feels personal. This collaboration enhances wedding video editing by aligning sound, story, and emotion naturally.' },
        { title: 'Handling Revisions with Professional Wedding Editing Practices', text: 'Revisions are part of quality wedding video editing services. Addressing requests with clarity and respect strengthens collaboration. Explaining creative choices while applying feedback maintains emotional consistency and storytelling balance.' },
        { title: 'Creating Long-Term Relationships Through Memorable Delivery', text: 'A positive client experience doesn\'t end with delivery. Following up, sharing previews, and inviting testimonials build lasting connections. Satisfied clients often recommend emotional wedding video editing services to others.' }
      ],
      conclusion: 'Timeless wedding films are shaped by strong communication and trust. When clients feel understood, the editing becomes more emotional and meaningful. Wedding video storytelling succeeds when connection leads the creative process.'
    }
  }
];

const BlogGallery = () => {
  const [selectedBlog, setSelectedBlog] = useState(null);
  const [imageLoaded, setImageLoaded] = useState(false);

  const openBlog = (e, post) => {
    if (e) e.preventDefault();
    setSelectedBlog(post);
    setImageLoaded(false);
  };

  const closeBlog = () => {
    setSelectedBlog(null);
    setImageLoaded(false);
  };

  // If a blog is selected, show the detail page
  if (selectedBlog) {
    return (
      <div id="blog" style={{ background: '#fafafa', paddingTop: '80px', paddingBottom: '80px', minHeight: '100vh' }}>
        <div style={{
          maxWidth: '900px',
          margin: '0 auto',
          padding: '0 20px',
          backgroundColor: '#fff',
          boxShadow: '0 10px 30px rgba(0, 0, 0, 0.05)',
          borderRadius: '8px',
          marginBottom: '50px'
        }}>
          {/* Back Button */}
          <div style={{ padding: '30px 40px 0' }}>
            <button
              onClick={closeBlog}
              style={{
                background: 'transparent',
                border: '2px solid #f7a01c',
                color: '#f7a01c',
                padding: '10px 25px',
                fontSize: '16px',
                cursor: 'pointer',
                borderRadius: '4px',
                fontWeight: '600',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = '#f7a01c';
                e.target.style.color = '#fff';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'transparent';
                e.target.style.color = '#f7a01c';
              }}
            >
              ← Back to Blog
            </button>
          </div>

          {/* Blog Content */}
          <div style={{ padding: '50px 40px' }}>
            <h1 style={{
              fontFamily: 'Montserrat, sans-serif',
              fontSize: '26px',
              fontWeight: '800',
              marginBottom: '30px',
              color: '#1f2d3d',
              textAlign: 'center',
              letterSpacing: '-0.5px',
              lineHeight: '1.2'
            }}>
              {selectedBlog.title}
            </h1>

            {/* Image with skeleton loader */}
            <div style={{ position: 'relative', marginBottom: '40px' }}>
              {!imageLoaded && (
                <div style={{
                  width: '100%',
                  height: '550px',
                  background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                  backgroundSize: '200% 100%',
                  animation: 'shimmer 1.5s infinite',
                  borderRadius: '6px'
                }} />
              )}
              <img
                src={selectedBlog.image}
                alt={selectedBlog.title}
                style={{
                  width: '100%',
                  height: 'auto',
                  maxHeight: '550px',
                  objectFit: 'cover',
                  objectPosition: selectedBlog.id === '1taz-EdwQo_hCTW8CRrQ3kNWVCLQ9t0pJ' ? 'center bottom' : 'center 30%',
                  borderRadius: '6px',
                  boxShadow: '0 10px 20px rgba(0, 0, 0, 0.2)',
                  display: imageLoaded ? 'block' : 'none'
                }}
                onLoad={() => setImageLoaded(true)}
              />
            </div>

            <h3 style={{
              fontSize: '32px',
              fontWeight: '700',
              color: '#34495e',
              borderLeft: '5px solid #f7a01c',
              paddingLeft: '15px',
              marginTop: '50px',
              marginBottom: '20px',
              letterSpacing: '2px'
            }}>
              Introduction
            </h3>
            <p style={{
              fontSize: '17px',
              color: '#444',
              marginBottom: '30px',
              lineHeight: '1.7'
            }}>
              {selectedBlog.content.intro}
            </p>

            <ol style={{
              paddingLeft: '0',
              margin: '30px 0',
              listStyle: 'none'
            }}>
              {selectedBlog.content.sections.map((section, idx) => (
                <li key={idx} style={{
                  padding: '20px 30px',
                  marginBottom: '30px',
                  backgroundColor: '#fcfcfc',
                  borderRadius: '4px',
                  border: '1px solid #f0f0f0'
                }}>
                  <h4 style={{
                    fontSize: '24px',
                    fontWeight: '700',
                    color: '#333',
                    marginBottom: '10px',
                    letterSpacing: '2px'
                  }}>
                    {idx + 1}. {section.title}
                  </h4>
                  <p style={{
                    fontSize: '17px',
                    color: '#444',
                    margin: 0,
                    lineHeight: '1.7'
                  }}>
                    {section.text}
                  </p>
                </li>
              ))}
            </ol>

            <h3 style={{
              fontSize: '32px',
              fontWeight: '700',
              color: '#34495e',
              borderLeft: '5px solid #f7a01c',
              paddingLeft: '15px',
              marginTop: '50px',
              marginBottom: '20px',
              letterSpacing: '2px'
            }}>
              Conclusion
            </h3>
            <p style={{
              fontSize: '17px',
              color: '#444',
              marginBottom: '20px',
              lineHeight: '1.7'
            }}>
              {selectedBlog.content.conclusion}
            </p>
          </div>
        </div>
      </div>
    );
  }

  // Default: Show blog gallery
  return (
    <div id="blog" style={{ background: '#fff', paddingTop: '80px', paddingBottom: '80px' }}>
      <div className="container">
        <div className="sixteen columns">
          <div className="section-top">
            <div className="line-dark"></div>
            <h1>OUR BLOG</h1>
            <div className="subtext-top">Latest News & Insights</div>
            <div className="line-dark1"></div>
          </div>
        </div>
      </div>

      <div style={{
        maxWidth: '1200px',
        margin: '60px auto 0',
        padding: '0 20px'
      }}>
        {blogPosts.map((post, index) => (
          <button
            key={post.id}
            type="button"
            onClick={() => openBlog(null, post)}
            style={{
              display: 'flex',
              flexDirection: index % 2 === 0 ? 'row' : 'row-reverse',
              gap: '40px',
              marginBottom: '60px',
              textDecoration: 'none',
              color: 'inherit',
              transition: 'transform 0.3s ease',
              alignItems: 'center',
              cursor: 'pointer',
              background: 'none',
              border: 'none',
              padding: 0,
              width: '100%',
              textAlign: 'left'
            }}
            className="blog-post-item"
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            <div style={{
              flex: '0 0 45%',
              overflow: 'hidden',
              borderRadius: '8px',
              boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
            }}>
              <img
                src={post.image}
                alt={post.title}
                style={{
                  width: '100%',
                  height: '300px',
                  objectFit: 'cover',
                  objectPosition: 'center bottom',
                  display: 'block',
                  transition: 'transform 0.5s ease'
                }}
                className="blog-image"
              />
            </div>

            <div style={{
              flex: '1',
              padding: '20px 0'
            }}>
              <h2 style={{
                fontSize: '24px',
                fontWeight: '700',
                color: '#2c3e50',
                marginBottom: '15px',
                lineHeight: '1.6',
                transition: 'color 0.3s ease',
                letterSpacing: '2px'
              }}
              className="blog-title"
              >
                {post.title}
              </h2>

              <p style={{
                fontSize: '15px',
                color: '#666',
                lineHeight: '1.8',
                margin: 0
              }}>
                {post.excerpt}
              </p>
            </div>
          </button>
        ))}
      </div>

      <style>{`
        .blog-post-item:hover .blog-image {
          transform: scale(1.05);
        }
        .blog-post-item:hover .blog-title {
          color: #d4af37;
        }

        @keyframes shimmer {
          0% {
            background-position: -200% 0;
          }
          100% {
            background-position: 200% 0;
          }
        }

        @media only screen and (max-width: 768px) {
          .blog-post-item {
            flex-direction: column !important;
          }
          .blog-post-item > div:first-child {
            flex: 0 0 100% !important;
          }
        }
      `}</style>
    </div>
  );
};

export default BlogGallery;
